var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"third-party"},_vm._l((_vm.thirdData),function(item,index){return _c('el-button',{key:index,on:{"click":function($event){return _vm.otherLogin(item)}}},[_vm._v(_vm._s(item.label))])}),1)}
var staticRenderFns = []

export { render, staticRenderFns }